export default class LinkedinControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.value = args.value ? args.value : ''
    this.input.id = window.PRIM.getUUID()
    this.input.type = 'text'
    this.input.autocapitalize = 'off'
    this.input.autocorrect = 'off'
    this.input.spellcheck = 'false'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let onclick = () => {
      if (this.input.value) {
        let parsedUsername = this.input.value.trim()
        if (parsedUsername) {
          open('https://www.linkedin.com/in/' + parsedUsername)
        }
      }
    }

    this.button = document.createElement('button')
    this.button.className = 'icon'
    this.button.onclick = onclick
    this.button.innerHTML = '\ue0f1'
    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)
    div.appendChild(this.button)

    element.appendChild(fragment)
  }

  click () {
    this.button.click()
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? this.input.value : null
  }

  setValue (value) {
    this.input.value = value ? value : ''
  }
}



// WEBPACK FOOTER //
// ./js/lib/ui/LinkedinControl.js